module.exports = __webpack_public_path__ + "static/img/智慧银行数字化展厅.2470334e.png";